// extracted by mini-css-extract-plugin
module.exports = {"paypal_modal__footer":"modal-footer-module--paypal_modal__footer--34B91"};